<template>
    <div>

        <Row>
            <DatePicker v-model="filterDate" placeholder="Pickup Date" type="daterange" :options="options2"
                        :clearable="false" format="dd/MM/yyyy" class="filterInput" style="width: 260px" @on-change="onChangeDate"></DatePicker>
            <Button style="float: right; margin:-5px 0 6px 0" @click="onAddTruckOrder">Start Order</Button>
            <Button style="float: right; margin:-5px 4px 6px 0" @click="driverListDialog=true">Drivers</Button>
            <Button style="float: right; margin:-5px 4px 6px 0" @click="truckListDialog=true">Trucks</Button>
        </Row>
        <Table :columns="headers" :data="truckOrders" size="small" stripe @on-row-click="openTruckOrderDetail" max-height="700">
            <template slot-scope="{ row }" slot="action">
                <template v-if="moment(filterDate, 'ddd MMMM DD YYYY').format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')">
                  <Icon type="md-create" @click.stop="onEditTruckOrder(row)" style="cursor: pointer"></Icon>
                  <Icon type="md-close" @click.stop="onDeleteTruckOrder(row)" style="margin-left: 8px; cursor: pointer"></Icon>
                </template>
                <Tooltip content="Download CSV" placement="bottom">
                    <Button @click.stop="onDownloadCSV(row)" style="font-weight: bolder;margin:0 0 0 7px">csv
                        <i class="fas fa-download" style="margin: 0 -8px 0 8px;font-size: 12px"></i></Button>
                </Tooltip>
            </template>
            <template slot-scope="{ row }" slot="status">
             {{row.status}}
                <Icon type="md-checkmark-circle" v-if="row.status=='InProgress'" @click="completeTruckOrder(row)" style="cursor: pointer"></Icon>
            </template>
        </Table>

        <add-truck-order ref="truck-order-form"></add-truck-order>
        <truck v-if="truckListDialog"></truck>
        <driver isLoadedIn="truckOrders" v-if="driverListDialog"></driver>

        <Drawer :mask-closable="true" class="demo-drawer-prime" title="Truck Order Detail" v-model="truckOrderDetailDrawer"
                width="720">
            <Row>
                <Col style="padding-top: 10px" v-if="selectedTruckOrder">
                    <Row>
                        <h3>Basic Detail | <span style="font-size: medium;font-weight: normal">{{selectedTruckOrder.truckOrderNumber}}</span>
                            <Tag style="float: right">{{selectedTruckOrder.status}}</Tag>
                        </h3>
                    </Row>
                    <Divider></Divider>
                    <Row>
                        <Col span="8">
                            <span style="font-size: 14px; color: #858585">Plate No.</span>
                            <p style="margin-bottom: 10px; font-size:17px">{{selectedTruckOrder.truck.platNo}}</p></Col>
                        <Col span="8">
                            <span style="font-size: 14px; color: #858585">Driver</span>
                            <p style="margin-bottom: 10px; font-size:17px">{{selectedTruckOrder.driverDetail?selectedTruckOrder.driverDetail.name:'-'}}</p>
                        </Col>
                        <Col span="8">
                            <span style="font-size: 14px; color: #858585">Transporter</span>
                            <p style="margin-bottom: 10px; font-size:17px">{{selectedTruckOrder.Transporter?selectedTruckOrder.Transporter.name:'-'}}</p>
                        </Col>
                        <Col span="8">
                            <span style="font-size: 14px; color: #858585">Eway Bill No.</span>
                            <p style="margin-bottom: 10px; font-size:17px">{{selectedTruckOrder.ewayBillNo?selectedTruckOrder.ewayBillNo:'-'}}</p></Col>
                        <Col span="8">
                            <span style="font-size: 14px; color: #858585">Pickup City</span>
                            <p style="margin-bottom: 10px; font-size:17px">{{selectedTruckOrder.fromCity}}</p></Col>
                        <Col span="8">
                            <span style="font-size: 14px; color: #858585">Drop City</span>
                            <p style="margin-bottom: 10px; font-size:17px">{{selectedTruckOrder.toCity}}</p></Col>
                        <Col span="8">
                            <span style="font-size: 14px; color: #858585">Commited Wt.</span>
                            <p style="margin-bottom: 10px; font-size:17px">{{selectedTruckOrder.commitedWeight}}</p></Col>
                        <Col span="8">
                            <span style="font-size: 14px; color: #858585">Price/Amount</span>
                            <p style="margin-bottom: 10px; font-size:17px">{{selectedTruckOrder.price}}</p></Col>
                        <Col span="8">
                            <span style="font-size: 14px; color: #858585">LR Commission</span>
                            <p style="margin-bottom: 10px; font-size:17px">{{selectedTruckOrder.lrCommision}}</p></Col>
                    </Row>
                    <Divider></Divider>
                    <div style="font-weight: bolder;font-size: 14px">
                        ORDERS ASSIGNED ({{selectedTruckOrder.orderDetailsArr.length}})
                    <span style="float: right">Total Wt.: {{calculateTotalWeightOfOrders(selectedTruckOrder.orderDetailsArr)}} kg</span></div>
                    <Card v-for="(order, index) in selectedTruckOrder.orderDetailsArr" :key="index">
                        <b>#{{order.order.orderNumber}}</b><br>
                        <b>Dealer</b> : {{order.order.clientobject.name}}<br>
                        {{order.order.pickuppartyobject.name}} ↔ {{order.order.droppingpartyobject.name}}<br>
                        {{order.order.pickuppartyobject.address[0].city}} ↔ {{order.order.droppingpartyobject.address[0].city}}<br>
                        <b>Material</b> : {{order.order.materials.type}} {{order.order.materials.boxes}} boxes | {{order.order.materials.kg}} Kg<br>
                        <template v-if="order.lrObject && order.lrObject.lrName"><b>LR No</b> : {{order.lrObject.lrName}}<br></template>
                        <template v-if="order.ewayBillNo"><b>Eway Bill No.</b> : {{order.ewayBillNo}} <Tag>{{order.isEwayBillVerified?'Verified':'Not Verified'}}</Tag><br></template>
                        <template v-if="order.order.note"><b>Note</b> : {{order.order.note}}</template>
                    </Card>
                    <template v-if="!selectedTruckOrder.orderDetailsArr.length">No Orders assigned yet.</template>
                </Col>
            </Row>
        </Drawer>

    </div>
</template>

<script>
    import {GET_TRUCK_ORDERS, GET_OCCUPIED_TRUCKS_AND_DRIVERS} from '../../graphql/queries/truckOrders'
    import {DELETE_TRUCK_ORDER, UPDATE_TRUCK_ORDER_STATUS} from '../../graphql/mutations/truckOrders'
    import {SUBSCRIBE_TRUCK_ORDERS, SUBSCRIBE_OCCUPIED_TRUCKS_AND_DRIVERS} from '../../graphql/subscription/truckOrders'
    import AddTruckOrder from './AddTruckOrder'
    import Truck from '../Settings/Truck'
    import Driver from '../Settings/Driver'
    import moment from 'moment'
    import { NetworkCommunicator } from '../../plugins/NetworkResourceHandler'
    import {Constants} from '../../Constants/Constant'
    export default {
        apollo: {
            truckOrders: {
                query: GET_TRUCK_ORDERS,
                variables(){
                    return{
                        startDate: this.startDate,
                        endDate: this.endDate,
                    }
                },
                subscribeToMore: {
                    document: SUBSCRIBE_TRUCK_ORDERS,
                    variables(){
                        return{
                            startDate: this.startDate,
                            endDate: this.endDate,
                        }
                    },
                    updateQuery: function(previousResult, { subscriptionData }) {
                        this.truckOrders = subscriptionData.data.truckOrders;
                    },
                },
                result ({ data, loading }) {
                    if (!loading) {
                        this.truckOrders = data.truckOrders;
                    }
                }
            },
            occupiedTruckAndDriverIds: {
                query: GET_OCCUPIED_TRUCKS_AND_DRIVERS,
                variables(){
                    return {
                        todayDate: moment().format('YYYY-MM-DD')
                    }
                },
                subscribeToMore: {
                    document: SUBSCRIBE_OCCUPIED_TRUCKS_AND_DRIVERS,
                    variables(){
                        return {
                            todayDate: moment().format('YYYY-MM-DD')
                        }
                    },
                    updateQuery: function(previousResult, { subscriptionData }) {
                        this.setTruckIdArrAndDriverIdArr(subscriptionData.data.occupiedTruckAndDriverIds)
                    },
                },
                result ({ data, loading }) {
                    if (!loading) {
                        this.setTruckIdArrAndDriverIdArr(data.occupiedTruckAndDriverIds)

                    }
                }
            },
        },
        name: "TruckOrders",
        components: {AddTruckOrder, Truck, Driver},
        data: function(){
            return{
                mutation_DELETE_TRUCK_ORDER: DELETE_TRUCK_ORDER,
                mutation_UPDATE_TRUCK_ORDER_STATUS: UPDATE_TRUCK_ORDER_STATUS,
                moment: moment,
                filterDate: [moment().format('DD/MM/YYYY'), moment().format('DD/MM/YYYY')],
                startDate: moment().format('YYYY-MM-DD'),
                endDate: moment().format('YYYY-MM-DD'),
                truckOrders: [],
                headers: [
                    {title: 'Date', key: 'date', width: 115,
                        render:(h, params) => {return h('div',moment(params.row.date).format('DD/MM/YYYY'))}},
                    {title: 'TONumber', key: 'truckOrderNumber', width: 185, className: "table-TONum-column",
                        renderHeader: function (h) {return h('div', [h('p', 'Truck Order'), h('p', 'Number')])}},
                    {title: 'Truck', key: 'truck',  width: 150,
                        render:(h, params) => {return h('div',params.row.truck.platNo)}},
                    {title: 'Driver', key: 'driverDetail', width: 150,
                        render:(h, params) => {return h('div',params.row.driverDetail.name)}},
                    {title: 'Eway Bill No.', key: 'ewayBillNo',  width: 177,
                        render:(h, params) => {return h('div',params.row.ewayBillNo)}},
                    {title: 'Orders Assigned', key: 'numOfOrdersAssigned',  width: 145,
                        renderHeader: function (h) {return h('div', [h('p', 'No. of Orders'), h('p', 'Assigned')])},
                        render:(h, params) => {return h('div',params.row.orderDetailsArr.length)}},
                    {title: 'Total Wt.', key: 'totalWeightOfOrders',  width: 110,
                        render:(h, params) => {return h('div',this.calculateTotalWeightOfOrders(params.row.orderDetailsArr))},
                        renderHeader: function (h) {return h('div', [h('p', 'Total Wt.'), h('p', '(kg)')])}},
                    {title: 'From City', key: 'fromCity', width: 130,
                        renderHeader: function (h) {return h('div', [h('p', 'Pickup'), h('p', 'City')])}},
                    {title: 'End City', key: 'toCity', width: 130,
                        renderHeader: function (h) {return h('div', [h('p', 'Drop'), h('p', 'City')])}},
                    {title: 'Booking Date', key: 'bookingDate', width: 117,
                        renderHeader: function (h) {return h('div', [h('p', 'Booking'), h('p', 'Date')])},
                        render:(h, params) => {return h('div',moment(params.row.bookingDate).format('DD/MM/YYYY'))}},
                    {title: 'Action', slot: 'action', width: 150},
                    {title: 'Status', slot: 'status',  width: 150,}
                ],
                addTruckOrderDrawer: false,
                occupiedTruckIdArr: [],
                occupiedDriverIdArr: [],
                truckOrderDetailDrawer: false,
                selectedTruckOrder: '',
                options2: {
                    shortcuts: [
                        {
                            text: 'Today',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                return [start, end];
                            }
                        },
                        {
                            text: '1 month',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                                return [start, end];
                            }
                        },
                        {
                            text: '3 months',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                                return [start, end];
                            }
                        }
                    ]
                },
                truckListDialog: false,
                driverListDialog: false,
            }
        },
        methods: {
            onChangeDate(evt){
                this.startDate = moment(evt[0], 'DD/MM/YYYY').format('YYYY-MM-DD')
                this.endDate = moment(evt[1], 'DD/MM/YYYY').format('YYYY-MM-DD')
            },
            calculateTotalWeightOfOrders(arrList){
                let totalWeightOfOrders = 0
                if(arrList.length > 1){
                    let sum = arrList.reduce((a,b) => ({order: {materials:{ kg: parseInt(a.order.materials.kg) + parseInt(b.order.materials.kg)}}}))
                    totalWeightOfOrders = sum.order.materials.kg
                }else if(arrList.length === 1){
                    totalWeightOfOrders = arrList[0].order.materials.kg
                }
                return totalWeightOfOrders
            },
            openTruckOrderDetail(rowData, rowindex){
                this.selectedTruckOrder = rowData
                this.truckOrderDetailDrawer = true
            },
            completeTruckOrder(row){
                let self = this
                this.$apollo.mutate({
                    mutation: this.mutation_UPDATE_TRUCK_ORDER_STATUS,
                    variables: { truckOrderId: row.id, status: 'Completed' }
                }).then(function(response){
                    self.$Message.success('Truck Order updated successfully!');
                }).catch(function(err){})
            },
            onAddTruckOrder(){
                this.$refs['truck-order-form'].editMode = false;
                this.addTruckOrderDrawer = true;
            },
            setTruckIdArrAndDriverIdArr(truckAndDriverIds){
                if(truckAndDriverIds.length){
                    let truckIdArr = [];
                    let driverIdArr = [];
                    truckAndDriverIds.forEach(function(curnt){
                        truckIdArr.push(curnt.truckId);
                        driverIdArr.push(curnt.driverId);
                    })
                    this.occupiedTruckIdArr = truckIdArr;
                    this.occupiedDriverIdArr = driverIdArr;
                }else{
                    this.occupiedTruckIdArr = [];
                    this.occupiedDriverIdArr = [];
                }
            },
            onEditTruckOrder(row){
                this.$refs['truck-order-form'].editMode = true;
                this.$refs['truck-order-form'].setTruckOrderForm(row);
                this.addTruckOrderDrawer = true;
            },
            onDeleteTruckOrder(row){
              this.$refs['truck-order-form'].onDeleteTruckOrder(row.id);
            },

            async onDownloadCSV(row){
                let response = await NetworkCommunicator('GET',
                    `${Constants.api_url}truckOrderReport/${row.id}`, false)
                if (response) {
                    var csvContent = 'data:text/csv;charset=utf-8,'+response
                    var encodedUri = encodeURI(csvContent);
                    var link = document.createElement("a");
                    link.setAttribute("href", encodedUri);
                    link.setAttribute("download", row.truckOrderNumber+".csv");
                    document.body.appendChild(link); // Required for FF

                    link.click();
                    // console.log('resp', response)
                } else {
                    this.$Message.error('Fail to download csv file')
                }
            }
        }
    }
</script>

<style scoped>
    /deep/ .ivu-table td {
        font-size: 15px;
    }
    /deep/ .ivu-table td.table-TONum-column{
        font-size: 14px;
    }
    .filterInput{
        width: 80%;
    }
    /deep/ .ivu-date-picker-cells  {
        font-size: 12px !important;
    }
    /deep/ .ivu-picker-panel-sidebar  {
        width:98px !important;
    }
</style>
